import CompanySettingPage from './CompanySettingPage.container';

export default CompanySettingPage;
